export default __webpack_public_path__ + "static/giftcards-scam-fbc2ccbae028f2b1851bebe078c659d3.webp";